import { Link, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { useTransactionView } from '@features/transactions/contexts/transactionViewContext'

interface InvoiceTransactionLinkProps {
  transactionId: string
  transactionNo: number | null
}

export const InvoiceTransactionLink = ({ transactionId, transactionNo }: InvoiceTransactionLinkProps): ReactElement => {
  const { handleTransactionClick } = useTransactionView()

  const handleClick = useCallback(() => {
    handleTransactionClick({ id: transactionId, transactionNo })
  }, [handleTransactionClick, transactionId, transactionNo])

  return (
    <Text as="span" inline onClick={handleClick} variant="bodySM" weight="bold">
      <Link withAnimation>{transactionNo}</Link>
    </Text>
  )
}
